import TransferBySerial from '@/api/stock/transfer-by-serial'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  edit_data: {},
  from_warehouses: [],
  to_warehouses: [],
  branches: [],
  products: [],
  uom: [],
  serialStatus: [],
  categoryAvailable: [],
  productAvailable: [],
  transfer_type: '',
  status_id: 1,
  location_id: [],
  available_quantity: 0,
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {
  getUomNameById: state => uomId => {
    return state.uom.find(u => u.uom_id == uomId).uom_name_en
  },
  getProdcutById: state => productId => {
    return state.products.find(p => p.product_id == productId)
  },
  getProdcutGroupById: state => productId => {
    return state.products.find(p => p.product_id == productId).group
      .pro_group_name_en
  },
  totalAmount: (state, getters) => detail => {
    try {
      let amount = detail.cost * detail.quantity
      return _.ceil(amount, 2)
    } catch (e) {
      return 0
    }
  },
  isDefaultUom: state => productId => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .map(el => el.uom_category.unit_of_measures)
        .flat()
        .filter(d => d.is_default == true)
        .map(el => el.uom_id)
        .reduce((init, value) => (init = value))
    }
    return null
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_FROM_WAREHOUSES(state, data) {
    state.from_warehouses = data
  },
  SET_TO_WAREHOUSES(state, data) {
    state.to_warehouses = data
  },
  SET_BRANCHES(state, data) {
    state.branches = data
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_UOM(state, data) {
    state.uom = data
  },
  SET_SERIAL_STATUS(state, data) {
    state.serialStatus = data
  },
  SET_TRANSFER_TYPE(state, data) {
    state.transfer_type = data
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_CATEGORY_AVAILABLE(state, date) {
    state.categoryAvailable = date
  },
  SET_PRODUCT_AVAILABLE(state, date) {
    state.productAvailable = date
  },
  SET_AVAILABLE_QUANTITY(state, data) {
    state.available_quantity = data
  },
  SET_STATUS_ID(state, data) {
    state.status_id = data
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ','),
          transfer_type: context.state.transfer_type,
          status_id: context.state.status_id
        }
      },
      attrubutes
    )
    return TransferBySerial.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return TransferBySerial.store(data)
  },

  update(context, data) {
    return TransferBySerial.update(data)
  },
  destroy(context, id) {
    return TransferBySerial.destroy(id)
  },

  confirm(context, data) {
    return TransferBySerial.updateStatus(data)
  },

  reject(context, data) {
    return TransferBySerial.updateStatus(data)
  },

  getProductSearch(context, attribute = {}) {
    return TransferBySerial.productSearch({ params: attribute })
  },
  getProductAvailableSearch(context, attribute = {}) {
    return TransferBySerial.productAvailableSearch({ params: attribute })
  },
  getNewSerialByQty(context, attribute = {}) {
    return TransferBySerial.getNewSerialByQty({ params: attribute })
  },

  availableQuantity(context, attribute = {}) {
    return TransferBySerial.sysQty({ params: attribute })
  },
  async getFromWarehouses(context, attribute = {}) {
    let response = await TransferBySerial.fromWarehouse({ params: attribute })
    context.commit('SET_FROM_WAREHOUSES', response.data)
  },
  async getToWarehouses(context, attribute = {}) {
    let response = await TransferBySerial.toWarehouse({ params: attribute })
    context.commit('SET_TO_WAREHOUSES', response.data)
  },
  async getCategoryAvailable(context, attribute = {}) {
    let category = await TransferBySerial.getCategoryAvailable({
      params: attribute
    })
    context.commit('SET_CATEGORY_AVAILABLE', category)
  },
  async getProductAvailable(context, attribute = {}) {
    let product = await TransferBySerial.getProductAvailable({
      params: attribute
    })
    context.commit('SET_PRODUCT_AVAILABLE', product)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await TransferBySerial.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.branches.length > 0) {
      let response = await TransferBySerial.branch()
      context.commit('SET_BRANCHES', response.data)
    }
    if (!context.state.products.length > 0) {
      let response = await TransferBySerial.product()
      context.commit('SET_PRODUCT', response.data)
    }
    if (!context.state.uom.length > 0) {
      let response = await TransferBySerial.uom()
      context.commit('SET_UOM', response.data)
    }
    if (!context.state.serialStatus.length > 0) {
      let response = await TransferBySerial.getSerialStatus()
      context.commit('SET_SERIAL_STATUS', response.data)
    }
    return Promise.resolve()
  },
  printPdf(context, attribute = {}) {
    return TransferBySerial.printPdf({ params: attribute })
  },
  async checkReceiveMonthDiffMonthTransfer(context, data) {
    return await TransferBySerial.checkReceiveMonthDiffMonthTransfer(data)
  },
  exportExcel(context, data) {
    return TransferBySerial.exportExcel(data)
  }
}
